export const Throw = (e: unknown) => {
  throw e;
};
